import Instance from '../../../../utils/Axios';

const GetObrasRegistoEscritorio =
  (estadosProjetoPreSelectedId, estadosSubProjetoPreSelectedId) => async (dispatch) => {
    const stateToken = localStorage.token;

    const estadosProjetosId = estadosProjetoPreSelectedId;
    const estadosSubProjetosId = estadosSubProjetoPreSelectedId;

    if (stateToken) {
      await Instance()
        .get('/obras/registohorasescritorio', {
          params: {
            estadosProjetosId,
            estadosSubProjetosId,
          },
        })
        .then(({ data }) => {
          if (stateToken) {
            dispatch({ type: 'GET_OBRAS_REGISTO_ESCRITORIO', payload: data.yData });
          }
        })
        .catch(({ err }) => console.log(err));
    }
  };

export default GetObrasRegistoEscritorio;
